/**
 * Cliente HTTP de Público: wrappers tipados sobre `req()` de campana-nueva, como Emails. Nunca se manda el comercio
 * (sale del token) y la ficha va por la clave opaca, nunca por un celular o un mail.
 */

import { req } from "../campana-nueva/api";
import { qs } from "../wa-oficial/api";
import type { Resp } from "../wa-oficial/api";
import type * as T from "./types";

const B = "/activa/publico";

const qsFiltros = (f: T.FiltrosPublico = {}) =>
  qs({
    q: f.q || undefined,
    segmento: f.segmento || undefined,
    canal: f.canal,
    actividad: f.actividad,
    orden: f.orden && f.orden !== "reciente" ? f.orden : undefined,
    pagina: f.pagina && f.pagina > 1 ? f.pagina : undefined,
    porPagina: f.porPagina,
  });

export const publicoApi = {
  resumen: (): Promise<Resp<T.ResumenPublico>> => req("GET", `${B}/resumen`),
  lista: (f?: T.FiltrosPublico): Promise<Resp<T.PaginaPublico>> => req("GET", `${B}${qsFiltros(f)}`),
  persona: (clave: string): Promise<Resp<T.FichaPublico>> => req("GET", `${B}/personas/${encodeURIComponent(clave)}`),
  // Del equipo
  exportar: (f?: Omit<T.FiltrosPublico, "pagina" | "porPagina">): Promise<Resp<T.ExportacionPublico>> => req("GET", `${B}/exportar${qsFiltros(f)}`),
  /** Responde 202: arma en segundo plano; el avance se lee en `resumen().estado`. 409 si ya se está armando. */
  actualizar: (): Promise<Resp<{ enCurso: boolean }>> => req("POST", `${B}/actualizar`, {}),
};
